import DefaultMutator from './DefaultMutator.js';
function install(molten) {
  molten.addPlugin('OpenApiMutator', DefaultMutator);
}
export default {
  install
};